var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyalty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 19.07h4.105a5.131 5.131 0 015.131 5.132M5.746 24.202h10.262a4.105 4.105 0 014.105 4.105 1.026 1.026 0 01-1.026 1.027H2.667M19.6 19.07l-8.21-7.594C6.915 6.981 13.442-1.72 19.6 5.32c6.157-7.02 12.746 1.683 8.21 6.157l-8.21 7.595z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgLoyalty;